export default "__VITE_ASSET__9748d532__"